import { forwardRef, type SelectHTMLAttributes } from 'react';
import clsx from 'clsx';
import { ChevronDown } from '@/components/icons';
import { fieldBase } from './Input';

export interface SelectOption {
  value: string;
  label: string;
}

export interface SelectGroup {
  label: string;
  options: SelectOption[];
}

export const Select = forwardRef<
  HTMLSelectElement,
  SelectHTMLAttributes<HTMLSelectElement> & { options: SelectOption[]; /** Shown after `options`, each under its label. */ groups?: SelectGroup[]; wrapperClassName?: string }
>(function Select({ options, groups, className, wrapperClassName, ...rest }, ref) {
  return (
    <div className={clsx('relative', wrapperClassName)}>
      <select ref={ref} className={clsx(fieldBase, 'appearance-none pr-10', className)} {...rest}>
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
        {groups
          ?.filter((g) => g.options.length > 0)
          .map((g) => (
            <optgroup key={g.label} label={g.label}>
              {g.options.map((o) => (
                <option key={o.value} value={o.value}>
                  {o.label}
                </option>
              ))}
            </optgroup>
          ))}
      </select>
      <ChevronDown className="pointer-events-none absolute top-1/2 right-4 size-3 -translate-y-1/2 text-fg-secondary" aria-hidden />
    </div>
  );
});
